import { config } from '@/forms/config';
import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
} from '@/forms/typings';
import type { FileFormField } from '@/forms/typings';
import { generateValidations } from '@/forms/utils/generateValidations';

import type { FormFieldModuleContext } from '../registry/field-module.types';

export function buildFileInitialState(
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions: FormConditionalValidation[] | undefined,
  ctx: FormFieldModuleContext,
): { initialValues: FormInitialValues; validationFields: FormValidations } {
  let initialValues: FormInitialValues = { ...values };
  let validationFields: FormValidations = { ...validations };

  const f = field as FileFormField;

  if (f.notApplicableField) {
    initialValues[f.notApplicableField.fieldId] = f.notApplicableField.value;
  }

  initialValues[`${f.fieldId}${config.minFilesCountFieldSuffix}`] = Object.keys(
    f.fileNames ?? {},
  ).length;

  const schemaMinFiles = generateValidations(f, conditions, true);

  if (schemaMinFiles) {
    validationFields[`${f.fieldId}${config.minFilesCountFieldSuffix}`] =
      schemaMinFiles;
  }

  if (f.naDetails && f.notApplicableField) {
    const combinedNAConditions: FormConditionalValidation[] = [
      { type: 'not-applicable', relatedFieldId: f.notApplicableField.fieldId },
      ...(conditions ?? []),
    ];

    const naValuesAndValidations = ctx.recurse(
      f.naDetails,
      initialValues,
      validationFields,
      combinedNAConditions,
    );

    initialValues = {
      ...initialValues,
      ...naValuesAndValidations.initialValues,
    };
    validationFields = {
      ...validationFields,
      ...naValuesAndValidations.validationFields,
    };
  }

  return { initialValues, validationFields };
}
